import React, { useRef } from 'react'
import PropTypes from 'prop-types';
import toString from 'lodash/toString';
import {
  Textarea,
  Select,
  Input,
  Dropdown,
  Tooltip,
  InfoCard,
} from 'app/components';
import {
  Globe,
  Lock,
  Question,
  MapTrifold,
  VideoCamera,
  MapPin,
} from '@phosphor-icons/react';

import './style'
import { EVENT_TYPE_OPTIONS, VISIBILITY_OPTIONS, EVENT_CATEGORY } from '../../containers/step1/constants';
import { INDIAN_CITIES } from '../../constants';

const EventAbout = (props) => {
  const {
    setFormData,
    formData,
    error,
    setError,
  } = props;

  const scrollContainerRef = useRef(null); // added

  const handleSelectChange = (field, options, id) => {
    let clears = {};
    const selectedValue = options[id].id;
    if (field === 'type') {
      if (selectedValue === 'offline') {
        clears = {
          meeting_link: '',
          meeting_id: '',
          meeting_password: '',
        };
      } else {
        clears = {
          event_address: {
            venue: '',
            address_line_1: '',
            address_line_2: '',
            city: '',
            location: {
              lat: 13.067439,
              lng: 80.237617,
            },
          },
        };
      }
    }
    setFormData({
      ...formData,
      [field]: selectedValue,
      ...clears,
    });
    setError({
      ...error,
      [`${field}Error`]: '',
    });

    // scroll to bottom
    if (scrollContainerRef.current && field === 'type') {
      setTimeout(() => {
        scrollContainerRef.current.scrollTo({
          top: scrollContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }, 0);
    }
  };

  const handleInputChange = (field, value) => {
    const errorMsg = value.length > 50
      ? 'Should be less than 50 characters to catch viewer’s attention easily.'
      : value === ''
        ? 'Enter an event name to proceed'
        : '';
    setFormData({
      ...formData,
      [field]: value
    });
    setError({
      ...error,
      [`${field}Error`]: errorMsg,
    });
  };

  const onChangeCity = (id, menuItem) => {
    if (id !== formData?.geo_location) {
      setFormData({
        ...formData,
        geo_location: id,
        event_address: {
          location: {
            lat: menuItem?.Latitude,
            lng: menuItem?.Longitude,
          },
          state: menuItem?.State,
        },
      });
    }
    setError({
      ...error,
      ['geo_locationError']: '',
    });
  };

  const onChangeCategory = (id, menuItem) => {
    if (id !== formData?.category) {
      setFormData({
        ...formData,
        category: id,
      });
      setError({
        ...error,
        categoryError: '',
      });
    }
  };


  return (
    <>
      <h1 className='heading-36 mb-9'>What’s your event about?</h1>

      <div className='event-about-container flex flex-col gap-8 overflow-auto pr-4' ref={scrollContainerRef}>
        <Textarea
          className={`event-name ${error.nameError ? 'error-text' : ''}`}
          width="100%"
          label="Event name"
          charLength={50}
          value={formData?.name}
          validationStatus={error.nameError && 'error'}
          helpText={error.nameError}
          onChange={(e) => handleInputChange('name', e.target.value)}
        />

        <Dropdown
          width="100%"
          value={formData.category}
          label="Event Category"
          placeholder="Select Event Category"
          options={EVENT_CATEGORY}
          onChange={onChangeCategory}
        />

        <div className='flex flex-col w-full gap-2'>
          <label className={`label-16 ${error.visibilityError ? 'text-error' : 'text-grey-70'}`}>
            Visibility
          </label>

          <div className='flex gap-2 self-stretch '>
            {VISIBILITY_OPTIONS.map((option, id) => (
              <Tooltip
                key={id}
                content={id === 0 ?
                  'Visible for everyone.' :
                  'Visible only with whom you share the event link. Best suited for college events.'
                }
              >
                <p className="grow">
                  <Select
                    width="100%"
                    label={option.label}
                    icon={id === 0 ? <Globe size={24} /> : <Lock size={24} />}
                    selected={toString(formData.visibility) === option.id}
                    onClick={() => handleSelectChange('visibility', VISIBILITY_OPTIONS, id)}
                  />
                </p>
              </Tooltip>
            ))}
          </div>
          {error.visibilityError && <p className='text-error text-xs'>{error.visibilityError}</p>}
        </div>

        <div className='flex flex-col w-full gap-2'>
          <label className={`label-16 ${error.typeError ? 'text-error' : 'text-grey-70'}`} >
            Event type {'  '}
            <Tooltip className="text-center"
              content="Choose whether your event will be held in person or online.">
              <p className='inline-block'>
                <Question className='inline-block'
                  size={20} />
              </p>
            </Tooltip>
          </label>

          <div className='flex gap-2 self-stretch '>
            {EVENT_TYPE_OPTIONS.map((option, id) => (
              <Select
                key={id}
                className="grow"
                label={option.label}
                icon={id === 0 ? <MapTrifold size={24} /> : <VideoCamera size={24} />}
                selected={formData.type === option.id}
                onClick={() => handleSelectChange('type', EVENT_TYPE_OPTIONS, id)}
              />
            ))}
          </div>
          {error.typeError && <p className='text-error text-xs'>{error.typeError}</p>}
        </div>

        {formData.type != 'online' &&
          (<Dropdown width="100%"
            className="city-dropdown"
            label="City"
            options={INDIAN_CITIES}
            value={formData?.geo_location}
            hasSearch={true}
            onChange={onChangeCity}
            validationStatus={error.geo_locationError && 'error'}
            errorMessage={error.geo_locationError}
          />)
        }
      </div>
    </>
  )
}

EventAbout.propTypes = {
  setFormData: PropTypes.func,
  formData: PropTypes.object,
  error: PropTypes.object,
  setError: PropTypes.func,
};

EventAbout.defaultProps = {
  setFormData: () => { },
  formData: {},
  error: {},
  setError: () => { },
};


export default EventAbout